import { FC } from 'react'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { MtcDriversTableRow } from 'mtcTypes'
import { useDriverTableStyles } from './MolecularBiomarkersTableRow.styles'
import ProgressBarWithValueIndicator from '../../../components/progressbar/ProgressBarWithValueIndicator'

type MtcDriversTableRowType = {
    isRowOpen?: boolean
    handleRowCollapse?: (rowId: number) => void
    row: MtcDriversTableRow
    maxGbs: number
    shouldNavigate?: boolean
    collapsable: boolean
}

const DriversTableRow: FC<MtcDriversTableRowType> = ({
    row,
    shouldNavigate,
    isRowOpen,
    handleRowCollapse,
    collapsable,
    maxGbs
}) => {
    const styles = useDriverTableStyles()
    const { t } = useTranslation('common')

    const onTogglingRow = (id: number) => {
        handleRowCollapse && handleRowCollapse(id)
    }

    return (
        <TableRow className={isRowOpen ? styles.noBorderBottom : ''}>
            <TableCell
                onClick={() => {
                    onTogglingRow(row.id)
                }}
                className={styles.chevronCell}
            >
                {' '}
            </TableCell>

            <TableCell
                className={`${styles.cell} ${styles.colWidth200} ${styles.variantNoNav}`}
            >
                <span className="simpleCell font-16">
                    {shouldNavigate ? (
                        <Link to={`./${row.id}`}>{row.variant}</Link>
                    ) : (
                        row.variant
                    )}
                </span>
            </TableCell>
            <TableCell className={`${styles.cell} ${styles.colWidth200}`}>
                {row.driverClassification
                    ? t(`tableRowLabels.${row.driverClassification}`)
                    : ``}
            </TableCell>

            <TableCell className={styles.cell}>
                {!isNaN(Number(row.gbs)) ? (
                    <ProgressBarWithValueIndicator
                        max={maxGbs}
                        current={row.gbs}
                        negative={row.gbs < 0}
                    />
                ) : (
                    ''
                )}
            </TableCell>
        </TableRow>
    )
}

export default DriversTableRow
